// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zlW--TetherPosition--container{position:absolute;display:flex}html.m-ie .zlW--TetherPosition--container{display:block}.iYg--TetherPosition--emptyContainer,.i9G--TetherPosition--preflight{opacity:0;pointer-events:none}.iYg--TetherPosition--emptyContainer{position:absolute;display:flex;left:0;top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "zlW--TetherPosition--container",
	"m-ie": "m-ie",
	"emptyContainer": "iYg--TetherPosition--emptyContainer",
	"preflight": "i9G--TetherPosition--preflight"
};
module.exports = ___CSS_LOADER_EXPORT___;
